<template>
  <div name="hrms-search-box-higher-order">
    <div class="col-xs-12">
      <div class="form-group clearfix">
        <label>{{searchBoxLabels[boxType]}} <span class="text-red">{{checkRequire}}</span> </label>
        <hrms-datepicker      v-if="checkBoxType('DATE', boxType)"
                                :disabled="disableBox('DATE', condition)"
                                v-model="inputValue[boxType]"
                                v-validate="rules"
                                data-vv-value-path="inputDate"
                                :data-vv-as="boxType"
                                :data-vv-name="boxType"
                                :name="boxType"
                                @change.native="onInputValueChanged(condition, $event.target.value)"
                                @changeInputDate="onInputValueChanged(condition, arguments[0])" />

        <hrms-timepicker      v-if="checkBoxType('TIME', boxType)"
                                :disabled="disableBox('DATE', condition)"
                                v-model="inputValue[boxType]"
                                v-validate="rules"
                                data-vv-value-path="inputTime"
                                :data-vv-as="boxType"
                                :data-vv-name="boxType"
                                :name="boxType"
                                @change.native="onInputValueChanged(condition, $event.target.value)"
                                @changeInputTime="onInputValueChanged(condition, arguments[0])" />

        <hrms-lov-codcomp    v-if="checkBoxType('LOVCODCOMP', boxType)"
                                v-model="inputValue[boxType]"
                                :nowLang="nowLang"
                                v-validate="rules"
                                data-vv-value-path="inputValue"
                                :data-vv-as="boxType"
                                :data-vv-name="boxType"
                                :name="boxType" 
                                @change.native="onInputValueChanged(condition, $event.target.value)"
                                @changeLov="onInputValueChanged(condition, arguments[0])" />
        <hrms-lov-codcomp2   v-if="checkBoxType('LOVCODCOMP2', boxType)"
                                v-model="inputValue[boxType]"
                                :nowLang="nowLang"
                                v-validate="rules"
                                data-vv-value-path="inputValue"
                                :data-vv-as="boxType"
                                :data-vv-name="boxType"
                                :name="boxType" 
                                @change.native="onInputValueChanged(condition, $event.target.value)"
                                @changeLov="onInputValueChanged(condition, arguments[0])" />
        <hrms-lov             v-if="checkBoxType('LOV', boxType)"
                                :disabled="disableBox('LOV', condition)"
                                v-model="inputValue[boxType]"
                                :nowLang="nowLang"
                                :lovType="findLovType(boxType)"
                                v-validate="rules"
                                data-vv-value-path="inputValue"
                                :data-vv-as="boxType"
                                :data-vv-name="boxType"
                                :descDisp="findLovDisp(boxType)"
                                :name="boxType" 
                                @change.native="onInputValueChanged(condition, $event.target.value)"
                                @changeLov="onInputValueChanged(condition, arguments[0])"
                                @setDataRow="setDataRowSearchbox(boxType, arguments[0])" />

        <hrms-dropdown        v-if="checkBoxType('DROPDOWN', boxType)"
                                v-model="inputValue[boxType]"
                                :options="genDropdowns(boxType)"
                                v-validate="rules"
                                data-vv-value-path="inputValue"
                                :data-vv-as="boxType"
                                :data-vv-name="boxType"
                                @change.native="onInputValueChanged(condition, $event.target.value)" />

        <hrms-dropdown-year   v-if="checkBoxType('DROPDOWNYEAR', boxType)"
                                v-model="inputValue[boxType]"
                                :nowLang="nowLang"
                                @change.native="onInputValueChanged(condition, $event.target.value)" />

        <hrms-dropdown-month  v-if="checkBoxType('DROPDOWNMONTH', boxType)"
                                v-model="inputValue[boxType]" 
                                :nowLang="nowLang" 
                                @change.native="onInputValueChanged(condition, $event.target.value)" />

        <input                v-if="checkBoxType('INPUTTEXT', boxType)"
                                v-model="inputValue[boxType]"
                                v-validate="rules"
                                :data-vv-as="boxType"
                                :name="boxType"
                                type="text"
                                @change="onInputValueChanged(condition, $event.target.value)"
                                class="form-control" />
        <textarea             v-if="checkBoxType('TEXTAREA', boxType)"
                                v-model="inputValue[boxType]"
                                v-validate="rules"
                                :data-vv-as="boxType"
                                :name="boxType"
                                type="text"
                                @change="onInputValueChanged(condition, $event.target.value)"
                                class="form-control"
                                rows="6" />
        <input                v-if="checkBoxType('INPUTNUMBER', boxType)"
                                v-model="inputValue[boxType]"
                                v-validate="rules"
                                :data-vv-as="boxType"
                                :name="boxType"
                                type="number"
                                min="0"
                                @change="onInputValueChanged(condition, $event.target.value)"
                                class="form-control" />

        <hrms-logical-statement v-if="checkBoxType('LOGICALSTMT', boxType)"
                                v-model="inputValue[boxType]"
                                v-validate="rules"
                                data-vv-value-path="submitCodeStmt"
                                :data-vv-as="boxType"
                                :data-vv-name="boxType"
                                :listFields="listFields"
                                @changeStatement="onInputValueChanged(condition, arguments[0])"
                                :nowLang="nowLang" />
        <span v-show="errors.has(boxType)" class="text-error">{{ errors.first(boxType) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import bus from 'assets/js/bus'

export default {
  name: 'hrms-search-box-higher-order',
  data () {
    return {
      inputValue: this.value,
      dataRow: {}
    }
  },
  mounted () {
    bus.$on('veeValidate', () => {
      this.$validator.validateAll().then(result => {
        this.$emit('validateEvent', result)
      }).catch(result => {
        this.$emit('validateEvent', false)
      })
    })
  },
  computed: {
    checkRequire () {
      return (this.rules).search('requiredWhen') > -1 ? '' : (this.rules).search('required') > -1 ? '*' : ''
    }
  },
  watch: {
    value () {
      this.inputValue = this.value
    },
    inputValue: {
      handler () {
        this.$nextTick(function () {
          this.$validator.validateAll().then(() => {}).catch(() => {})
        })
      },
      deep: true
    }
  },
  methods: {
    setDataRowSearchbox (boxType, dataRow) {
      this.$set(this.dataRow, boxType, dataRow)
      this.$emit('setDataRowSearchbox', this.dataRow)
    },
    findLovDisp (type) {
      if (type === 'nummemmo' || type === 'batchno') {
        return false
      } else {
        return true
      }
    },
    disableBox (type, condition) {
      switch (type) {
        case 'DATE':
          if (condition === 'approve') {
            return this.inputValue.staappr === 'P'
          } else {
            return false
          }
        case 'LOV':
          if (condition === 'hresh1x') {
            return true
          } else {
            return false
          }
        default:
          return false
      }
    },
    disableDisplay (condition) {
      switch (condition) {
        case 'hresz2u':
          return false
        default:
          return true
      }
    },
    onInputValueChanged (condition, newVal) {
      if (condition === 'approve') {
        if (newVal === 'P') {
          this.inputValue.dteapprst = ''
          this.inputValue.dteappren = ''
        }
      }
      this.$emit('input', this.inputValue)
    }
  },
  props: [ 'boxType', 'rules', 'condition', 'searchBoxLabels', 'nowLang', 'value', 'findLovType', 'checkBoxType', 'genDropdowns', 'listFields' ]
}
</script>



// WEBPACK FOOTER //
// higherOrder.vue?3ce90d8b